var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34087 6.06021L12 2.40146L15.659 6.06087L13.7504 8.40445L12.4429 9.70873L12.4427 9.70901C12.325 9.82656 12.1655 9.89258 11.9992 9.89258C11.8329 9.89258 11.6733 9.82656 11.5557 9.70901L11.5555 9.70887L10.2489 8.40459L8.34087 6.06021Z",
    stroke: "#875BF7",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34087 18.0602L12 14.4015L15.659 18.0609L13.7504 20.4044L12.4429 21.7087L12.4427 21.709C12.325 21.8266 12.1655 21.8926 11.9992 21.8926C11.8329 21.8926 11.6733 21.8266 11.5557 21.709L11.5555 21.7089L10.2489 20.4046L8.34087 18.0602Z",
    stroke: "#875BF7",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34087 12.0602L5.99996 8.40146L9.65903 12.0609L7.7504 14.4044L6.44295 15.7087L6.44267 15.709C6.32498 15.8266 6.16547 15.8926 5.99917 15.8926C5.83286 15.8926 5.67335 15.8266 5.55566 15.709L5.55552 15.7089L4.2489 14.4046L2.34087 12.0602Z",
    stroke: "#875BF7",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3409 12.0602L18 8.40146L21.659 12.0609L19.7504 14.4044L18.4429 15.7087L18.4427 15.709C18.325 15.8266 18.1655 15.8926 17.9992 15.8926C17.8329 15.8926 17.6733 15.8266 17.5557 15.709L17.5555 15.7089L16.2489 14.4046L14.3409 12.0602Z",
    stroke: "#875BF7",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.e2c1e4a6f0a9023e8ae9209f3ad832cf.svg";
export { ForwardRef as ReactComponent };